import { createApiSlice } from "@common";
import {
  CRUD_OPPORTUNITY_DETAIL,
  GET_OPPORTUNITY_DETAIL_BY_OPPORTUNITY_ID,
} from "@routes";

const apiConfig = [
  {
    name: "addOpportunityDetail",
    method: "post",
    url: CRUD_OPPORTUNITY_DETAIL,
    stateKey: "message",
  },
  {
    name: "getOpportunityDetailByOpportunityId",
    method: "get",
    url: GET_OPPORTUNITY_DETAIL_BY_OPPORTUNITY_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "opportunityDetail",
  apiConfig,
  customReducers
);
const opportunityDetailSlice = slice;

export default opportunityDetailSlice.reducer;

export const {
  addOpportunityDetail,
  getOpportunityDetailByOpportunityId,
} = thunks;

export const { rowSelect } = actions;
